var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.toggleFullScreen}},[_c('pdf',{staticStyle:{"cursor":"zoom-in"},attrs:{"src":_vm.src}}),_c('a-modal',{attrs:{"visible":_vm.isFullScreen,"width":"50%","footer":null},on:{"cancel":_vm.toggleFullScreen}},[_c('pdf',{staticStyle:{"height":"100%"},attrs:{"src":_vm.src}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }